import {
    AfterViewChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    inject,
    Input,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { PageConfig, PageConfigAction } from '@core/models/page-config.model';
import { InputType } from '@capturum/builders/core';
import { FontAwesomeIcon } from '@core/enums/font-awesome-icon.enum';
import { take } from 'rxjs';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PageHeaderComponent implements AfterViewChecked {
    @Input()
    public pageConfig: PageConfig;

    @ViewChild('titleInner')
    private titleInner?: ElementRef<HTMLElement>;

    public inputType = InputType;
    public fontAwesomeIcon = FontAwesomeIcon;
    public titleTruncated = false;

    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    /**
     * Whether the title is cut off can only be measured once the new text is in the DOM. Reading it from the
     * template instead measures the *previous* title, because an element's own bindings are evaluated before
     * the text node below it is filled in — on a page that sets its config once, that leaves the tooltip off
     * for good.
     */
    public ngAfterViewChecked(): void {
        const element = this.titleInner?.nativeElement;
        const truncated = !!element && element.scrollWidth > element.clientWidth;

        if (truncated !== this.titleTruncated) {
            this.titleTruncated = truncated;
            this.changeDetectorRef.detectChanges();
        }
    }

    public buttonClicked(button: PageConfigAction) {
        if (button.disabled === undefined) {
            button.callback();
        } else if (typeof button.disabled === 'boolean' && !button.disabled) {
            button.callback();
        } else if (typeof button.disabled === 'object') {
            button.disabled.pipe(take(1)).subscribe((disabled) => { if (!disabled) button.callback()} );
        }
    }

    public typeOf(object: any) {
        return typeof object;
    }
}
